/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_04_BeginnerInputs */

const en_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you hit the ball, your arms bend and your head comes up to watch it fly. That is not a mistake. That is a good swing finishing the way it should.`)
};

const es_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando golpeas la bola, tus brazos se doblan y la cabeza se levanta para verla volar. Eso no es un error. Eso es un buen swing terminando como debe.`)
};

const de_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Sie den Ball schlagen, beugen Sie Ihre Arme und heben Ihren Kopf, um ihn fliegen zu sehen. Das ist kein Fehler. Das ist ein guter Schwung, der so zu Ende geht, wie er sollte.`)
};

const zh_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`击球时，你的手臂会弯曲，头会抬起来看球飞出去。这不是错误，而是一个好的挥杆按应有的方式收尾。`)
};

const ar_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عندما تضرب الكرة، تنثني ذراعاك ويرتفع رأسك لتشاهدها وهي تطير. هذا ليس خطأ. بل هو سوينغ جيد يكتمل كما ينبغي.`)
};

const fr_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorsque vous frappez la balle, vos bras se plient et votre tête se relève pour la regarder voler. Ce n'est pas une erreur. C’est un bon swing qui se termine comme il se doit.`)
};

const vi_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khi bạn đánh bóng, cánh tay gập và đầu ngẩng lên để nhìn bóng bay. Đó không phải lỗi. Đó là swing tốt đang kết thúc đúng cách.`)
};

const sw_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unapopiga mpira, mikono yako hukunjika na kichwa chako huinuka kuutazama ukiruka. Hilo si kosa. Hiyo ni swing nzuri ikimalizika jinsi inavyopaswa.`)
};

const th_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมื่อคุณตีลูก แขนจะงอและศีรษะจะเงยขึ้นมองลูกลอยไป นั่นไม่ใช่ความผิดพลาด แต่คือสวิงที่ดีซึ่งจบลงอย่างที่ควรเป็น`)
};

const bs_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kad udariš loptu, ruke se savijaju i glava se diže da je vidiš kako leti. To nije greška. To je dobar swing koji završava kako treba.`)
};

const ja_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ボールを打つと、腕が曲がり、ボールの行方を見るために頭が上がります。それはミスではありません。良いスイングが本来あるべき形で終わっているのです。`)
};

const ko_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공을 치면 팔이 구부러지고, 공이 날아가는 것을 보려고 고개가 들립니다. 그것은 실수가 아닙니다. 좋은 스윙이 원래대로 마무리되는 모습입니다.`)
};

const pt_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando você acerta a bola, os braços dobram e a cabeça sobe para vê-la voar. Isso não é erro. É um bom swing terminando como deve.`)
};

const it_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando colpisci la palla, le braccia si piegano e la testa si alza per guardarla volare. Non è un errore. È un buon swing che si conclude come dovrebbe.`)
};

const sv_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`När du träffar bollen böjs dina armar och huvudet kommer upp för att se den flyga. Det är inte ett misstag. Det är en bra sving som avslutas som den ska.`)
};

const nl_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als je de bal raakt, buigen je armen en komt je hoofd omhoog om hem te zien vliegen. Dat is geen fout. Dat is een goede swing die eindigt zoals het hoort.`)
};

const da_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Når du rammer bolden, bøjer dine arme, og hovedet kommer op for at se den flyve. Det er ikke en fejl. Det er et godt sving, der afsluttes som det skal.`)
};

const nb_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Når du treffer ballen, bøyer armene seg og hodet kommer opp for å se den fly. Det er ikke en feil. Det er en god sving som avsluttes slik den skal.`)
};

const fi_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun lyöt palloa, kätesi koukistuvat ja pääsi nousee katsomaan pallon lentoa. Se ei ole virhe. Se on hyvä svingi, joka päättyy niin kuin pitääkin.`)
};

const pl_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiedy uderzasz piłkę, Twoje ręce się zginają, a głowa unosi się, by zobaczyć jej lot. To nie jest błąd. To dobry swing, który kończy się tak, jak powinien.`)
};

const ru_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Когда вы бьёте по мячу, руки сгибаются, а голова поднимается, чтобы увидеть его полёт. Это не ошибка. Это хороший свинг, который завершается так, как должен.`)
};

const tr_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topa vurduğunuzda kollarınız bükülür ve başınız topun uçuşunu izlemek için kalkar. Bu bir hata değildir. Bu, olması gerektiği gibi biten iyi bir swingdir.`)
};

const hi_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जब आप गेंद मारते हैं, आपकी बाँहें मुड़ती हैं और सिर उड़ान देखने के लिए ऊपर आता है। यह गलती नहीं है। यही अच्छा स्विंग है जो सही तरह से समाप्त होता है।`)
};

const id_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat Anda memukul bola, lengan Anda menekuk dan kepala Anda terangkat untuk melihat bola melayang. Itu bukan kesalahan. Itulah ayunan yang baik yang selesai sebagaimana mestinya.`)
};

const ms_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apabila anda memukul bola, lengan anda membengkok dan kepala anda terangkat untuk melihat bola terbang. Itu bukan kesilapan. Itulah hayunan yang baik yang berakhir sebagaimana sepatutnya.`)
};

const cs_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Když udeříte do míče, paže se pokrčí a hlava se zvedne, abyste viděli jeho let. To není chyba. To je dobrý švih, který končí tak, jak má.`)
};

const el_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Όταν χτυπάτε την μπάλα, τα χέρια σας λυγίζουν και το κεφάλι ανεβαίνει για να τη δει να πετάει. Αυτό δεν είναι λάθος. Είναι ένα καλό σβινγκ που τελειώνει όπως πρέπει.`)
};

const he_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כשאתם חובטים בכדור, הזרועות שלכם מתכופפות והראש עולה כדי לראות אותו עף. זו לא טעות. זה סווינג טוב שמסתיים בדיוק כמו שצריך.`)
};

const af_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As jy die bal tref, buig jou arms en kom jou kop op om te kyk hoe dit vlieg. Dit is nie 'n fout nie. Dit is 'n goeie swaai wat klaarmaak soos dit moet.`)
};

const hu_method_content_step_04_beginner = /** @type {(inputs: Method_Content_Step_04_BeginnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amikor elütöd a labdát, a karod behajlik, a fejed felemelkedik, hogy nézze a röptét. Ez nem hiba. Ez egy jó swing, amely úgy fejeződik be, ahogy kell.`)
};

/**
* | output |
* | --- |
* | "When you hit the ball, your arms bend and your head comes up to watch it fly. That is not a mistake. That is a good swing finishing the way it should." |
*
* @param {Method_Content_Step_04_BeginnerInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_04_beginner = /** @type {((inputs?: Method_Content_Step_04_BeginnerInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_04_BeginnerInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_04_beginner(inputs)
	if (locale === "de") return de_method_content_step_04_beginner(inputs)
	if (locale === "zh") return zh_method_content_step_04_beginner(inputs)
	if (locale === "ar") return ar_method_content_step_04_beginner(inputs)
	if (locale === "fr") return fr_method_content_step_04_beginner(inputs)
	if (locale === "vi") return vi_method_content_step_04_beginner(inputs)
	if (locale === "sw") return sw_method_content_step_04_beginner(inputs)
	if (locale === "th") return th_method_content_step_04_beginner(inputs)
	if (locale === "bs") return bs_method_content_step_04_beginner(inputs)
	if (locale === "ja") return ja_method_content_step_04_beginner(inputs)
	if (locale === "ko") return ko_method_content_step_04_beginner(inputs)
	if (locale === "pt") return pt_method_content_step_04_beginner(inputs)
	if (locale === "it") return it_method_content_step_04_beginner(inputs)
	if (locale === "sv") return sv_method_content_step_04_beginner(inputs)
	if (locale === "nl") return nl_method_content_step_04_beginner(inputs)
	if (locale === "da") return da_method_content_step_04_beginner(inputs)
	if (locale === "nb") return nb_method_content_step_04_beginner(inputs)
	if (locale === "fi") return fi_method_content_step_04_beginner(inputs)
	if (locale === "pl") return pl_method_content_step_04_beginner(inputs)
	if (locale === "ru") return ru_method_content_step_04_beginner(inputs)
	if (locale === "tr") return tr_method_content_step_04_beginner(inputs)
	if (locale === "hi") return hi_method_content_step_04_beginner(inputs)
	if (locale === "id") return id_method_content_step_04_beginner(inputs)
	if (locale === "ms") return ms_method_content_step_04_beginner(inputs)
	if (locale === "cs") return cs_method_content_step_04_beginner(inputs)
	if (locale === "el") return el_method_content_step_04_beginner(inputs)
	if (locale === "he") return he_method_content_step_04_beginner(inputs)
	if (locale === "af") return af_method_content_step_04_beginner(inputs)
	if (locale === "hu") return hu_method_content_step_04_beginner(inputs)
	return en_method_content_step_04_beginner(inputs)
});